import React, { useState, useEffect, Fragment } from 'react';
import { Card, CardBody, Row, Button } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import './css/property.scss';
import MessageResponse from './ResponseBlock/MessageResponse';
import HeroCardResponse from './ResponseBlock/HeroCardResponse';
import ImageCarouselResponse from './ResponseBlock/ImageCarouselResponse';
import PublishGPT from '../components/PublishGPT/PublishGPT';
import { RotateSpinner } from 'react-spinners-kit';
import Sidemenu from './Sidemenu/Sidemenu';
import ExampleHeroCardResponse from './ResponseBlock/ExampleHeroCardResponse';
import ExampleResponse from './ResponseBlock/ExampleResponse';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { postAPI_TrackEvent, gAPI_Users_By_Id } from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';

function ResponseBlockHeroCard({ getUrl, propertyId, locale, email, lang, isSuperAdmin }) {
  const [responseData, setResponseData] = useState(null);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(lang);
  const [userName, setUserName] = useState("");
  const [isButtonShow, setIsButtonShow] = useState(true);
  const [filledCount, setFilledCount] = useState(0);
  const [blankCount, setBlankCount] = useState(0);
  const [filters, setFilters] = useState({ filled: false, blank: false });

  const reloadBotResponse = async () => {
    setIsLoading(true);
    locale = lang;
    var languageCode = locale;
    if (locale === "zh-TW") {
      languageCode = "hk";
    }
    if (locale === "en") {
      languageCode = "en-US";
    }
    return await AxiosAPI({
      methed: 'get',
      url: `${getUrl}/?property_id=${propertyId}&group_id=${getGroupID()}&lang=${languageCode === 'en' ? 'en-US' : languageCode
        }`,
    })
      .then((res) => {
        setResult(res.data);
        let filled = 0;
        let blank = 0;

        res.data.forEach((item) => {
          if (item.response?.isExample === true) {
            blank++;
          } else {
            filled++;
          }
        });


        setFilledCount(filled);
        setBlankCount(blank);
        setIsLoading(false);
        //console.log('All Bot Response', res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    locale = lang;
    var languageCode = locale;
    if (locale === "zh-TW") {
      languageCode = "hk";
    }
    if (locale === "en") {
      languageCode = "en-US";
    }
    setSelectedLanguage(languageCode);
    reloadBotResponse();
    if (email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Knowledge Hub',
          email: email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      setUserName(res.data.fullName);
      var admin = false;
      var user = false;
      var agent = false;
      var sa = false;
      res.data.roles.forEach((r) => {
        if (r === 'User') { user = true; }
        if (r === 'Admin') { admin = true; }
        if (r === 'Agent') { agent = true; }
        if (r === 'SuperAdmin' || isSuperAdmin) { sa = true; }
      });
      if (sa === false && admin === false && user === false && agent === true) {
        setIsButtonShow(false);
      }
    });
  }, [lang]);

  useEffect(() => {
    setResponseData(result);
  }, [result, lang]);
  const handleFilterChange = (selectedFilters) => {
    const newFilters = {
      filled: selectedFilters.includes('Filled'),
      blank: selectedFilters.includes('Blank'),
    };
    setFilters(newFilters);
  };
  const generator = () => {
    if (responseData) {
      console.log(responseData);
      const filteredData = responseData.filter(item => {
        if (filters?.filled && item.response?.isExample === false) return true;
        if (filters?.blank && item.response?.isExample === true) return true;
        return !filters?.filled && !filters?.blank;
      });
      return filteredData.map((elem, index) => {
        switch (elem.response.type) {
          case 'example': {
            const isInsufficientResponse =
              elem?.query?.hintQuestion === 'Insufficient Response';
            return (
              <Fragment key={index}>
                {isInsufficientResponse ? (
                  <ExampleResponse
                    elem={{ ...elem }}
                    reloadBotResponse={reloadBotResponse}
                    showFav={false}
                    historyUpdator={userName}
                    selectedLang={selectedLanguage}
                    isButtonShow={isButtonShow}
                  />
                ) : (
                  <ExampleHeroCardResponse
                    elem={{ ...elem }}
                    reloadBotResponse={reloadBotResponse}
                    showFav={false}
                    selectedLang={selectedLanguage}
                    historyUpdator={userName}
                    isButtonShow={isButtonShow}
                  />
                )}
              </Fragment>
            );
          }

          case 'herocard':
            return (
              <Fragment key={index}>
                <HeroCardResponse
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={false}
                  selectedLang={selectedLanguage}
                  historyUpdator={userName}
                  isButtonShow={isButtonShow}
                />
              </Fragment>
            );
          case 'messages':
            return (
              <Fragment key={index}>
                <MessageResponse
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={false}
                  historyUpdator={userName}
                  selectedLang={selectedLanguage}
                  isButtonShow={isButtonShow}
                />
              </Fragment>
            );

          default:
            break;
        }
      });
    } else return null;
  };

  const onSearchKey = (e) => {
    setIsLoadingSearch(true);
    var serachtext = e.target.value.toLowerCase();
    var resdata = result.filter(a => a.query.code.toLowerCase().includes(serachtext)
      || a.query.hintQuestion.toLowerCase().includes(serachtext)
      || a.response.messages.join(",").toLowerCase().includes(serachtext)
    );
    setTimeout(() => {
      setResponseData(resdata);
      setIsLoadingSearch(false);
    }, 1000);
  };
  return (
    <Fragment>
      {isLoading ? (
        <Row>
          <Colxx xxs="5" className="mb-2"></Colxx>
          <Colxx xxs="2" className="mb-2">
            <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
          </Colxx>
          <Colxx xxs="5" className="mb-2"></Colxx>
        </Row>
      ) : (
        <Fragment>
          <Row className="mb-4">
            {/* <Colxx xxs="3" xs="3"></Colxx> */}
            <Colxx xxs="2" xs="2">
              <div
                className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top"
                style={{ width: '100%' }}
              >
                <input
                  type="text"
                  name="keyword"
                  id="search"
                  placeholder="Search for amemities, pools, food and more"
                  onKeyUp={(e) => onSearchKey(e)}
                  style={{ width: '100%' }}
                />
              </div>
            </Colxx>
            <Colxx xxs="4" xs="4">
              {/* {(getGroupID() === "a7e06370-a3bc-43ef-ba88-afb100137eca" ||
                getGroupID() === "af402810-8902-473b-a487-b04301549dac") &&
                (<a href="/app/pages/propinfo/publish-ai">
                  <Button
                    color="primary"
                    outline
                    size="xs"

                  >
                    Publish AI
                  </Button>
                </a>)
              } */}
              {(getGroupID() !== "a7e06370-a3bc-43ef-ba88-afb100137eca" &&
                getGroupID() !== "af402810-8902-473b-a487-b04301549dac" &&
                locale === "en") &&
                (<a href="/app/pages/propinfo/publish-ai">
                  <Button
                    color="primary"
                    outline
                    size="xs"

                  >
                    Publish AI
                  </Button>
                </a>)
              }</Colxx>
            <Colxx xxs="6" xs="6"></Colxx>
          </Row>
          <Colxx xxs="12" className="mb-2 text-right">
            <strong><hr /></strong>
          </Colxx>
          <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">

            <Row>
              <Colxx
                xxs="10"
                md="10"
                lg="10"
                className="mb-2 col-sm-12"
                style={{ paddingLeft: '0px', paddingRight: '5px' }}
              >
                <Card>
                  <CardBody>
                    {!isLoadingSearch ?
                      generator() :
                      <Row>
                        <Colxx xxs="5" className="mb-2"></Colxx>
                        <Colxx xxs="2" className="mb-2">
                          <RotateSpinner size={60} color="#4556AC" loading={isLoadingSearch} />
                        </Colxx>
                        <Colxx xxs="5" className="mb-2"></Colxx>
                      </Row>
                    }
                  </CardBody>
                </Card>
              </Colxx>
              <Colxx xxs="2" lg='2'>

                <Sidemenu allCount={result}
                  filledCount={filledCount && filledCount != null ? filledCount : 0}
                  blankCount={blankCount && blankCount != null ? blankCount : 0}
                  onFilterChange={handleFilterChange} />
              </Colxx>
            </Row>
          </Colxx>
        </Fragment>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings, usersListApp }) => {
  const { propertyId, locale, email } = settings;
  const { isSuperAdmin } = usersListApp;
  return {
    propertyId,
    locale,
    email,
    isSuperAdmin
  };
};

export default injectIntl(connect(mapStateToProps)(ResponseBlockHeroCard));
